import React from "react";
import { Row, Col } from "reactstrap";
import "./Projects.css";

class Projects extends React.Component {
  state = {};
  render() {
    return (
      <div className="Projects">
        <div className="container pb-3">
          <h1>PROJECTS</h1>
          <Row>
            <Col md="3" xs="6">
              <img width="80%" src="/images/bible.PNG" alt="bible" />
              <p className="Project-Title">Bible App</p>
              <p className="Project-Desctiption">
                A bible app implemented in react-native. &nbsp;
                <a href="https://github.com/wambuguguedison">Learn More</a>
              </p>
            </Col>
            <Col md="3" xs="6">
              <img width="80%" src="/images/sporgente.PNG" alt="sporgente" />
              <p className="Project-Title">Sporgente</p>
              <p className="Project-Desctiption">
                A projecting app that enables a speaker to project different
                content on two different screens. &nbsp;
                <a href="https://github.com/wambuguguedison">Learn More</a>
              </p>
            </Col>
            <Col md="3" xs="6">
              <img
                width="80%"
                src="/images/Bravo Leather.PNG"
                alt="bravo leather"
              />
              <p className="Project-Title">Bravo Leather</p>
              <p className="Project-Desctiption">
                An E-commerce plartform to order and deliver custom leather
                products. &nbsp;
                <a href="https://github.com/wambuguguedison">Learn More</a>
              </p>
            </Col>
            <Col md="3" xs="6">
              <img
                width="80%"
                src="/images/covid.png"
                alt="Covid 19 estimator"
              />
              <p className="Project-Title">Covid-19 Estimator</p>
              <p className="Project-Desctiption">
                An API to display statistics on Covid 19 &nbsp;
                <a href="https://github.com/wambuguguedison">Learn More</a>
              </p>
            </Col>
          </Row>
          <a
            className="btn btn-success"
            href="https://github.com/wambuguedison"
          >
            See All &nbsp;
            <i className="fab fa-github"></i>
          </a>
        </div>
      </div>
    );
  }
}

export default Projects;
